<section class="relative" [ngClass]="view.site?.id === 72 ? 'lg:pb-12' : ''">

  <!-- Image layers -->
  <div class="w-full lg:h-[500px] md:h-[300px] h-[140px] relative">
    <div class="absolute inset-0 bg-cover bg-top bg-no-repeat transition-opacity duration-[3000ms] ease-in-out banner-type05__image"
      [ngStyle]="{ 'background-image': 'url(' + view.imageLayer1 + ')' }"
      [ngClass]="{
        'opacity-100': view.activeLayer === 1,
        'opacity-0': view.activeLayer !== 1,
        'banner-type05__image--site-72': view.site?.id === 72
      }">
    </div>
    <div class="absolute inset-0 bg-cover bg-top bg-no-repeat transition-opacity duration-[3000ms] ease-in-out banner-type05__image"
      [ngStyle]="{ 'background-image': 'url(' + view.imageLayer2 + ')' }"
      [ngClass]="{
        'opacity-100': view.activeLayer === 2,
        'opacity-0': view.activeLayer !== 2,
        'banner-type05__image--site-72': view.site?.id === 72
      }">
    </div>
  </div>

  <!-- Search Widget: hanging below the banner -->
  <div
    class="w-[90%] max-w-7xl z-20 mx-auto mt-4 lg:mt-0 lg:absolute lg:left-1/2 lg:top-full lg:transform lg:-translate-x-1/2"
    [ngClass]="view.site?.id === 72 ? 'lg:-translate-y-[65%]' : 'lg:-translate-y-1/2'">
    <ul
      class="flex justify-start md:justify-center text-sm p-4 font-medium text-center bg-white rounded-t-lg w-full max-w-2xl overflow-x-auto"
      id="default-styled-tab" role="tablist">
      <li class="me-2">
        <button
          class="inline-block text-black px-5 py-2 hover:bg-primary-100 hover:text-primary-500 rounded-md uppercase transition [&.active]:text-primary-500 [&.active]:bg-primary-100"
          id="fights-tab" [class.active]="view.selectedTab === 'flight'" (click)="selectTab('flight')" type="button"
          role="tab" aria-controls="flights" aria-selected="true">
          Flights
        </button>
      </li>
      <li class="me-2">
        <button
          class="inline-block text-black px-5 py-2 rounded-md hover:text-primary-500 hover:bg-primary-100 uppercase transition [&.active]:text-primary-500 [&.active]:bg-primary-100"
          id="Packages-tab" [class.active]="view.selectedTab === 'package'" (click)="selectTab('package')" type="button"
          role="tab" aria-controls="packages" aria-selected="view.selectedTab === 'package'">
          Packages
        </button>
      </li>
    </ul>
    <div id="default-styled-tab-content" class="bg-white shadow-2xl rounded-b-xl md:rounded-tr-xl">
      @if (view.selectedTab === 'flight') {
      <div class="md:rounded-lg">
        <search-widget [panel]="{ type: 'flight' }" (tripChange)="tripChanged($event)"
          (searchChange)="searchChanged($event)"></search-widget>
      </div>
      } @if (view.selectedTab === 'package') {
      <div class="md:rounded-lg">
        <search-widget [panel]="{ type: 'package' }" (tripChange)="tripChanged($event)"
          (searchChange)="searchChanged($event)"></search-widget>
      </div>
      }
    </div>
  </div>
</section>
